import React, { useMemo } from "react";

import { Agent } from "../../../../../../../../../../services";
import { useTypedSelector } from "../../../../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const TitleCellContent: React.FC<TitleCellContent.Props> = ({ item }) => {
	const lang = useTypedSelector((state) => state.session.language);

	const content = useMemo(() => item.name?.[lang] ?? "", [item.name, lang]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace TitleCellContent {
	interface Props {
		item: Agent.Model;
	}
}

export default TitleCellContent;
